export default "__VITE_ASSET__2f8b0aa5__"